import { render, staticRenderFns } from "./AppMusic.vue?vue&type=template&id=b588ef56"
import script from "./AppMusic.vue?vue&type=script&lang=js"
export * from "./AppMusic.vue?vue&type=script&lang=js"
import style0 from "./AppMusic.vue?vue&type=style&index=0&id=b588ef56&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports